export default function determineSide(side) {
  switch (side) {
    case 'buy':
    case 'buy_to_open':
    case 'BTO':
      return 'BTO';
    case 'sell_short':
    case 'sell_to_open':
    case 'STO':
      return 'STO';
    case 'buy_to_cover':
    case 'buy_to_close':
    case 'BTC':
      return 'BTC';
    case 'sell_to_close':
    case 'sell':
    case 'STC':
      return 'STC';
    default: 
      return 'Unknown'
  }
}
